import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";
import SidePopup from "../SidePopup/SidePopup";
import HorizontalTabs from "../Horizontal-Tabs/HorizontalTabs";
import Button from "../Button/Button";
import experienceIcon from "../../Assets/Images/experience-icon.png";
import locationIcon from "../../Assets/Images/location_icon.png";
import salaryIcon from "../../Assets/Images/dollarIcon.png";
import jobIcon from "../../Assets/Images/jobTypeIcon.png";
import linkedInIcon from "../../Assets/Images/linkedinIcon.png";
import whatsAppIcon from "../../Assets/Images/whatsapp-icon.png";
import activeBulb from "../../Assets/Images/activeBulb.png";
import inactiveBulb from "../../Assets/Images/inactiveBulb.png";
import CriticalIcon from "../../Assets/Images/critical-icon.svg";
import HighIcon from "../../Assets/Images/high-icon.svg";
import LowIcon from "../../Assets/Images/low-icon.svg";
import MediumIcon from "../../Assets/Images/medium-icon.svg";
import { applyEllipsis } from "../Common-Function/CommonFunctions";
import {
  VYLABS_BASE_URL,
  CREATE_JOB_URL,
  GET_RECRUITER_BY_ID,
} from "../../helper/url_helper";
import { get } from "../../helper/Api_helper";
import { debounce } from "lodash";
import { Toast } from "../Toast-Snackbar/ToastSnackbar";
import styled from "@emotion/styled";
import { DynamicContext } from "../../Context/DynamicContext";
import JobEditForm from "./JobEditForm";
import CustomTooltip from "../Tooltip/Tooltip";
import editIcon from "../../Assets/Images/edit-track-icon.svg";
import deleteIcon from "../../Assets/Images/delete-red-icon.png";
import JobDetails from "../../Components/Applicant-Tracking/Jobs/JobsDetails";
import AssignedCandidates from "../../Components/Applicant-Tracking/Jobs/AssignedCandidates";
import RecommendCandidates from "../../Components/Applicant-Tracking/Jobs/RecommendCandidates";
import JobsDocumentsList from "../../Components/Applicant-Tracking/Jobs/JobsDocumentsList";
import OptionsData from "../../Assets/Json/StaticOptions.json";

export const ShareJobIconContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-left: 10px;
`;

const { StaticOptions = {} } = OptionsData || {};
const { priority: PRIORITY_OPTIONS = [] } = StaticOptions || {};

const PRIORITY_ICON_MAP = {
  CriticalIcon,
  HighIcon,
  MediumIcon,
  LowIcon,
};

const getPriority = (priority) => {
  const priorityData = PRIORITY_OPTIONS.find(
    (item) => Number(item.id ?? item.value) === Number(priority),
  );

  if (!priorityData) return null;

  return {
    ...priorityData,
    icon: PRIORITY_ICON_MAP[priorityData.icon],
    name: priorityData.name || priorityData.title,
  };
};

const JobsDetailsContainer = ({
  jobId,
  selectedJob,
  isEditingJob,
  // setIsEditingJob = () => {},
  activeTab,
  setActiveTab,
  formik,
  editedJobData = null,
  // sideDialogformik,
  handleEditJob = () => {},
  handleJobChange = () => {},
  saveJobChanges = () => {},
  handleDeleteJob = () => {},
  showDeleteJobButton = false,
  customTabContent = {},
  isEditable = true,
  resetJobEdit = () => {},
  showJobDetailsTab = true,
  showAssignedCandidatesTab = true,
  showRecommendedCandidatesTab = true,
  showDocumentsTab = true,
  hasSearched,
  // hasRecommendedJobs,
  isOpen,
  onClose,
  assignedCount = 0,
  setAssignedCount = () => {},
  onAssignedCountChange,
  jobDetails,
  hideSearchBox = false,
  isFetchingRecommendedCandidates = false,
  recommendedCandidateIds = [],
  recruiterOptions = [],
  onRecruiterSearch = () => {},
  onAssignedToChange = () => {},
  isLoadingRecruiters = false,
}) => {
  const {
    isFromCandidateRecommendedJobs,
    userDetails,
    formatDateWithUserTimezone,
  } = useContext(DynamicContext);
  const [shareJobLink, setShareJobLink] = useState("");
  const [jobCreatedUserName, setJobCreatedUserName] = useState("Loading...");

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!selectedJob?.user_id) {
        setJobCreatedUserName("Loading...");
        return;
      }
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_RECRUITER_BY_ID}?id=${selectedJob?.user_id}`,
        );
        if (response?.user) {
          setJobCreatedUserName(
            `${response?.user?.first_name} ${response?.user?.last_name}`,
          );
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setJobCreatedUserName("Unknown");
      }
    };

    fetchUserDetails();
  }, [selectedJob?.user_id]);

  const handleShareLink = useMemo(
    () =>
      debounce(
        async () => {
          try {
            const response = await get(
              VYLABS_BASE_URL,
              `${CREATE_JOB_URL}?id=${jobId}`,
            );
            if (response && response.share_url) {
              setShareJobLink(response.share_url);
            } else {
              console.error("response.share_url error");
            }
          } catch (error) {
            console.error("Error creating job URL:", error);
          }
        },
        300,
        { leading: true, trailing: false },
      ),
    [jobId],
  );

  useEffect(() => {
    if (jobId) {
      handleShareLink();
    }
    return () => handleShareLink.cancel();
  }, [handleShareLink, jobId]);

  useEffect(() => {
    if (
      isFromCandidateRecommendedJobs &&
      activeTab === "Recommended Candidates"
    ) {
      setActiveTab("Job Details");
    }
  }, [isFromCandidateRecommendedJobs, activeTab, setActiveTab]);

  useEffect(() => {
    if (isEditingJob && activeTab !== "Job Details") {
      setActiveTab("Job Details");
    }
  }, [isEditingJob, activeTab, setActiveTab]);

  const displayJob = isEditingJob ? editedJobData : selectedJob;
  const priorityData = getPriority(selectedJob?.priority);
  const effectiveJobDetails = useMemo(
    () =>
      jobDetails || {
        title: selectedJob?.title,
        skills: selectedJob?.skills || "",
        description: selectedJob?.description,
        job_type: selectedJob?.job_type,
        location: selectedJob?.location,
        years_experience: selectedJob?.years_experience,
        salary_min: selectedJob?.salary_min,
        salary_max: selectedJob?.salary_max,
        tags: selectedJob?.tags,
        priority: selectedJob?.priority,
      },
    [jobDetails, selectedJob],
  );
  const assignedCountChangeHandler = onAssignedCountChange || setAssignedCount;

  const getTabConfig = useCallback(() => {
    const shouldShowRecommendedCandidates =
      showRecommendedCandidatesTab &&
      !hasSearched &&
      !isFromCandidateRecommendedJobs;

    return [
      {
        key: "Job Details",
        visible: showJobDetailsTab,
        name: "Job Details",
      },
      {
        key: "Assigned Candidates",
        visible: showAssignedCandidatesTab,
        name: (
          <span>
            Assigned Candidates
            {activeTab === "Assigned Candidates" && (
              <span
                style={{
                  marginLeft: 6,
                  color: isFromCandidateRecommendedJobs ? "#7c3aed" : "#6860EE",
                  background: isFromCandidateRecommendedJobs
                    ? "#ede9fe"
                    : "#E0DEFF",
                  borderRadius: "999px",
                  padding: isFromCandidateRecommendedJobs
                    ? "2px 8px"
                    : "5px 10px",
                  fontWeight: 500,
                  fontSize: "0.92em",
                }}
              >
                {assignedCount}
              </span>
            )}
          </span>
        ),
      },
      {
        key: "Recommended Candidates",
        visible: shouldShowRecommendedCandidates,
        name: "Recommended Candidates",
      },
      {
        key: "Documents",
        visible: showDocumentsTab,
        name: "Documents",
      },
    ].filter((tab) => tab.visible);
  }, [
    activeTab,
    assignedCount,
    hasSearched,
    isFromCandidateRecommendedJobs,
    showAssignedCandidatesTab,
    showDocumentsTab,
    showJobDetailsTab,
    showRecommendedCandidatesTab,
  ]);

  const tabs = getTabConfig();
  const activeTabIndex = tabs.findIndex((tab) => tab.key === activeTab);

  useEffect(() => {
    const tabs = getTabConfig();
    if (tabs.length > 0 && activeTabIndex === -1) {
      setActiveTab(tabs[0].key);
    }
  }, [activeTabIndex, getTabConfig, setActiveTab]);

  const renderTabContent = () => {
    const currentTabIndex = activeTabIndex === -1 ? 0 : activeTabIndex;
    const activeTabConfig = tabs[currentTabIndex];
    const customContent = customTabContent?.[activeTabConfig?.key];

    if (typeof customContent === "function") {
      return customContent(activeTabConfig?.key);
    }

    if (customContent) {
      return customContent;
    }

    switch (activeTabConfig?.key) {
      case "Job Details":
        return (
          <JobDetails
            job={displayJob}
            isEditingJob={isEditingJob}
            onJobChange={handleJobChange}
          />
        );
      case "Assigned Candidates":
        return (
          <AssignedCandidates
            job={selectedJob}
            jobDescription={selectedJob?.description}
            jobId={selectedJob?.id || jobId}
            onAssignedCountChange={assignedCountChangeHandler}
          />
        );
      case "Recommended Candidates":
        return (
          <RecommendCandidates
            jobDetails={effectiveJobDetails}
            jobActiveTab={activeTab}
            jobId={selectedJob?.id || jobId}
            jobTitle={selectedJob?.title}
            hideSearchBox={hideSearchBox}
            isFetchingRecommendedCandidates={isFetchingRecommendedCandidates}
            recommendedCandidateIds={recommendedCandidateIds}
          />
        );
      case "Documents":
        return <JobsDocumentsList jobId={selectedJob?.id || jobId} />;
      default:
        return <div>No content available for this job.</div>;
    }
  };

  const shareUrlToLinkedIN = () => {
    const LinkedINSharelink = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareJobLink)}`;
    if (shareJobLink) {
      window.open(LinkedINSharelink, "_blank", "noopener,noreferrer");
    } else {
      Toast("error", "Error while sharing this job.");
    }
  };
  const shareUrlToWhatsApp = () => {
    const jobTitle = selectedJob?.title;
    const company = selectedJob?.subTitle;
    const location = selectedJob?.location;
    const salary =
      selectedJob?.salary_min && selectedJob?.salary_max
        ? `${selectedJob.salary_min} - ${selectedJob.salary_max} per annum`
        : null;

    const messageParts = [];
    if (jobTitle) messageParts.push(`📌 *${jobTitle}*`);
    if (company) messageParts.push(`🏢 ${company}`);
    if (location) messageParts.push(`📍 ${location}`);
    if (salary) messageParts.push(`💰 ${salary}`);

    const whatsappMessage =
      messageParts.length > 0
        ? `New Job Opportunity!\n\n${messageParts.join("\n")}\n\nApply now: ${shareJobLink}`
        : `New Job Opportunity!\n\nCheck it out: ${shareJobLink}`;

    const whatsappShareLink = `https://api.whatsapp.com/send?text=${encodeURIComponent(whatsappMessage)}`;

    if (shareJobLink) {
      window.open(whatsappShareLink, "_blank", "noopener,noreferrer");
    } else {
      Toast("error", "Error while sharing this job.");
    }
  };

  const headerContent = (
    <div
      className="jobs-side-dialog-card-header-outer"
      style={{ position: "sticky", top: 0, zIndex: 1 }}
    >
      <div className="jobs-header-and-button-container">
        <div className="jobs-side-dialog-card-header">
          <img alt="icon" src={jobIcon} />
          <div>
            <h3 style={{ margin: "0", width: "fit-content" }}>
              <CustomTooltip title={selectedJob?.title} arrow>
                <span>{applyEllipsis(selectedJob?.title, 20)}</span>
              </CustomTooltip>
            </h3>
            <p className="job-subtitle">{selectedJob?.subTitle}</p>
          </div>
          <div className="settings-icon">
            <span>
              <img
                src={selectedJob?.active ? activeBulb : inactiveBulb}
                alt={selectedJob?.active ? "active-bulb" : "inactive-bulb"}
                style={{ marginLeft: "20px" }}
              />
            </span>
          </div>
          <div className="create-update-details">
            <div className="company-dates">
              <span>
                Created at :{" "}
                {formatDateWithUserTimezone(selectedJob?.created_at) || "N/A"}
              </span>
              {/* <span>
                Updated at : {formatDateWithUserTimezone(selectedJob?.updated_at) || "N/A"}
              </span> */}
            </div>
            {userDetails?.tenant_id !== "8d01a95f87c7465a9b11998555631f66" && (
              <div className="company-dates">
                <span>Created By : {jobCreatedUserName}</span>
              </div>
            )}
          </div>
        </div>
        {isEditable && (
          <div className="jobs-side-dialog-card-right-header">
            <ShareJobIconContainer className="job-share-icons-container">
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  color: priorityData?.color || "#6B7280",
                  fontWeight: 600,
                }}
              >
                {priorityData?.icon && (
                  <img
                    src={priorityData.icon}
                    alt={priorityData.name}
                    style={{ width: "16px", height: "16px" }}
                  />
                )}
                {priorityData?.name}
              </span>
              <CustomTooltip title="Share on LinkedIn" arrow>
                <img
                  src={linkedInIcon}
                  alt="linkedInIcon"
                  onClick={shareUrlToLinkedIN}
                  style={{ paddingTop: "2px" }}
                />
              </CustomTooltip>
              <CustomTooltip title="Share on WhatsApp" arrow>
                <img
                  src={whatsAppIcon}
                  alt="whatsAppIcon"
                  onClick={shareUrlToWhatsApp}
                  style={{ paddingTop: "2px" }}
                />
              </CustomTooltip>
            </ShareJobIconContainer>
            {isEditingJob ? (
              <div className="job-edit-actions">
                <Button
                  label="Save"
                  event={saveJobChanges}
                  style={{ marginRight: "10px", padding: "8px 15px" }}
                  backgroundColor="#6860EE"
                  color="#FFFFFF"
                  border="none"
                />
                <Button
                  label="Cancel"
                  isCancel={true}
                  event={() => resetJobEdit()}
                  style={{ padding: "7px 15px", margin: "0" }}
                  color="#000"
                  border="1px solid #ddd"
                />
              </div>
            ) : (
              <>
                <CustomTooltip title="Edit Job" arrow>
                  <Button
                    event={handleEditJob}
                    iconSrc={editIcon}
                    iconWidth="25px"
                    style={{ padding: "7px 10px" }}
                    backgroundColor="transparent"
                    color="#FFFFFF"
                    border="none"
                    hoverd={false}
                  />
                </CustomTooltip>
                {showDeleteJobButton && (
                  <CustomTooltip title="Delete Job" arrow>
                    <Button
                      event={handleDeleteJob}
                      iconSrc={deleteIcon}
                      iconWidth="29px"
                      style={{ padding: "4px 10px", marginLeft: "-15px" }}
                      backgroundColor="transparent"
                      color="#FFFFFF"
                      border="none"
                      hoverd={false}
                    />
                  </CustomTooltip>
                )}
              </>
            )}
          </div>
        )}
        {/* <Button
          label="Post On LinkedIn"
          checked={sideDialogformik?.values?.linkedIn || false}
          iconSrc={linkedInIcon}
          iconWidth="15px"
          disabled={true}
          className="disabled-button"
        /> */}

        {/* <Button
          label="Post On Atolla"
          checked={sideDialogformik?.values?.atolla || false}
          iconSrc={atollaLogo}
          iconWidth="15px"
          disabled={true}
          className="disabled-button"
        /> */}
      </div>
    </div>
  );

  return (
    <SidePopup
      isOpen={isOpen}
      onClose={onClose}
      showHeader={true}
      sidePopupWidth={"82%"}
      headerContent={headerContent}
    >
      {selectedJob && (
        <div
          className="jobs-side-dialog-overall-container"
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="job-info-outer-container"
            style={{ overflowY: "hidden" }}
          >
            <div className="candidate-information">
              <div className="info-header">
                <img
                  src={experienceIcon}
                  alt="job-icon"
                  className="info-icon"
                />
                <h4 className="info-header-value">Experience</h4>
              </div>
              <h3 className="candidate-value">
                {selectedJob?.min_years_experience !== null &&
                selectedJob?.min_years_experience !== undefined
                  ? selectedJob?.max_years_experience !== null &&
                    selectedJob?.max_years_experience !== undefined
                    ? `${selectedJob.min_years_experience} - ${selectedJob.max_years_experience} Years`
                    : `${selectedJob.min_years_experience}+ Years`
                  : "N/A"}
              </h3>
            </div>
            <div className="candidate-information">
              <div className="info-header">
                <img src={locationIcon} alt="job-icon" className="info-icon" />
                <h4 className="info-header-value">Location</h4>
              </div>
              <h3 className="candidate-value">
                {selectedJob.location || "N/A"}
              </h3>
            </div>
            <div className="candidate-information">
              <div className="info-header">
                <img src={salaryIcon} alt="job-icon" className="info-icon" />
                <h4 className="info-header-value">Salary</h4>
              </div>
              <h3 className="candidate-value">
                {selectedJob?.salary_min || "N/A"} -{" "}
                {selectedJob?.salary_max || "N/A"}
              </h3>
            </div>
            <div className="candidate-information">
              <div className="info-header">
                <img src={jobIcon} alt="job-icon" className="info-icon" />
                <h4 className="info-header-value">Job Type</h4>
              </div>
              <h3 className="candidate-value">
                {selectedJob?.job_type || "N/A"}
              </h3>
            </div>
            <div className="candidate-information">
              <div className="info-header">
                <img src={jobIcon} alt="job-icon" className="info-icon" />
                <h4 className="info-header-value">Openings</h4>
              </div>
              <h3 className="candidate-value">
                {selectedJob?.openings
                  ? `${selectedJob.openings} Positions`
                  : "N/A"}
              </h3>
            </div>
          </div>
          <div
            className="job-tabs-container"
            style={{
              position: "sticky",
              top: "auto",
              bottom: 0,
              zIndex: 1,
              padding: "0 20px",
            }}
          >
            <HorizontalTabs
              activeTab={activeTabIndex === -1 ? 0 : activeTabIndex}
              handleTabChange={(index) => {
                const tabs = getTabConfig();
                const targetTab = tabs[index]?.key;
                if (!targetTab) return;

                if (isEditingJob && targetTab !== "Job Details") {
                  Toast(
                    "warning",
                    "Please save or cancel your changes before switching tabs",
                  );
                  return;
                }

                setActiveTab(targetTab);
              }}
              tabNames={tabs.map(({ name }) => ({ name }))}
              tabstyle={{
                marginBottom: "0",
              }}
              customActiveClass="job-tab-active"
            />
          </div>
          <div
            className="job-content-container"
            style={{ flex: 1, overflowY: "auto" }}
          >
            {isEditable && isEditingJob && (
              <JobEditForm
                formik={formik}
                recruiterOptions={recruiterOptions}
                onRecruiterSearch={onRecruiterSearch}
                onAssignedToChange={onAssignedToChange}
                isLoadingRecruiters={isLoadingRecruiters}
              />
            )}
            {renderTabContent()}
          </div>
        </div>
      )}
    </SidePopup>
  );
};

export default JobsDetailsContainer;
